export const REQUEST_CU_BRANCH = "request_cu_branch"
export const CU_BRANCH_SUCCESS = "cu_branch_success"
export const CU_BRANCH_FAILURE = "cu_branch_failure"

export const CLEAR_CUBRANCH_STATE = "clear_cubranch_state"